<template lang="pug">
  div.registry.operators
    e-toolbar(
    :items="items"
      @deleteItems="deleteItems"
        :hideRemoveButton="true"
        :showTotal="true"
    :showExport="true"
    :endpointExport="getExportEndpoint()"
    )
    e-table(
    :items="items"
      @deleteItem="deleteItem"
        @editItem="editItem"
        :showCheckbox="false"
    )

    router-view
</template>

<script>
  import {tko, export_document} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"

  export default {
    mixins: [tableMixin],
    methods: {
      getEndpoint(route, fromRoute){
        return tko.operators(route)
      },
      getDeleteUrl(id){
        return tko.operatorDelete(id)
      },
      getExportEndpoint(){
        return export_document.tkoOperator(this.$route)
      }
    }
  };
</script>
